import { Link, Navigate } from 'react-router-dom';
import { handleApiErrors } from '../../../api/apiErrorHandler';
import { apiUrl } from '../../../api/apiUrl';
import http, { postHeaders } from '../../../api/axios';
import { useAuth } from '../../../context/AuthContext';
import { SignInForm } from '../../../forms/SignIn/SignInForm';
import { Values } from '../../../forms/SignIn/SignInForm.types';
import logger from '../../../utils/logger';
import { useLoading } from '../../../context/loadingContext';

/**
 * A component for the login page
 */
export const SignInPage = () => {
  const { isAuthenticated, login } = useAuth();
  const { startLoading, stopLoading } = useLoading();
  /**
   * Handles signin form submit.
   * Sends signin API.
   * @param values form data
   */
  const handleSubmit = async (values: Values) => {
    logger.i(values);
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.LOGIN,
        data: values,
        config: { ...postHeaders },
      });
      if (response?.status === 200) {
        stopLoading();
        const { token } = response.data;
        login(token);
      } else {
        stopLoading();
        logger.e(response?.status);
        logger.e(response);
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  if (isAuthenticated) return <Navigate to="/dashboard" />;

  return (
    <div className="mx-auto min-h-full h-screen flex items-center justify-center max-w-md py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl w-full space-y-8">
        <div className="mb-10">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Sign In</h2>
        </div>
        <SignInForm onSubmit={handleSubmit} />
        <p className="mt-2 text-center text-sm text-gray-600 mt-5">
          Don't have and account yet?{' '}
          <Link to="/register" className="font-medium text-blue-600 hover:text-blue-500">
            Sign Up.
          </Link>
        </p>
        <p className="text-center text-sm text-gray-600">
          <Link to="/forgot-password" className="font-medium text-blue-600 hover:text-blue-500">
            I forgot the password.
          </Link>
        </p>
      </div>
    </div>
  );
};
